import React, {useEffect, useState} from "react";
import axios from "axios";
import {serverLink} from "../../../resources/url";
import Select from "react-select";

function SchoolsSelectOption(props) {
    const [IsLoading, setIsLoading] = useState(true)
    const [itemData, setItemData] = useState([])
    const [formData, setFormData] = useState({
        Item: "",
        ItemObject: "",
    })
    const getData = async () => {
        await axios.get(`${serverLink}staff/academics/school/option/list`)
            .then((result) => {
                let rows = [];
                if (result.data.length > 0) {
                    result.data.map((row) => {
                        rows.push({ value: row.SCH_ID, label: row.SCHOOL })
                    });
                    setItemData(rows);
                }
                setIsLoading(false)
            })
            .catch((err) => {
                console.log("NETWORK ERROR");
            });
    }
    useEffect(()=> {
        getData();
    }, [""])

    const onItemChange = (e) => {
        props.setFormData({
            ...props.formData,
            SCH_ID:e.value
        })
        setFormData({
            ...formData,
            Item: e.value,
            ItemObject: e,
        })
    }

    return (
        <Select
            name="SCH_ID"
            value={!props.formData.SCH_ID ? formData.ItemObject : itemData.filter((e,i)=> e.value.toString() === props.formData.SCH_ID.toString())[0]}
            onChange={onItemChange}
            options={itemData}
            placeholder="select School"
        />
    )
}

export default SchoolsSelectOption;